import React, { useEffect, useState } from "react";
import { Getdata } from "../../helpers/api.service";

const Subjects = () => {
  const [data, setData] = useState([]);
  let [loading, setLoading] = useState(false);
  const fetchData = () => {
    setLoading(true);
    Getdata(
      process.env.REACT_APP_URL +
      `/front/education/subject/fetch/${process.env.REACT_APP_SUBDOMAIN}`
    )
      .then((res) => {
        console.log("News API response:", res);
        if (res?.data) {
          setData(res.data);
        }
        // setImages(res.data.map((item) => item.image));
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching news:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4 text-start">
        {data.length > 0 &&
          data.map((item, index) => (
            <div
              key={index}
              className="border-[#EAEAEA] bg-[#F9F5FF] border-[1px] rounded-lg p-4  relative text-gray-800 flex flex-col"
            >
              {/* Title */}
              <h2
                className="text-2xl font-semibold mb-2 break-words line-clamp-2  transition-all duration-300"
                title={item.name}
              >
                {item.name}
              </h2>

              {/* Department */}
              <div className="text-sm mb-4 break-words">{item.department}</div>

              {/* Recommended Books */}
              <div className="mb-4">
                <h3 className="font-semibold mb-1 text-lg">
                  Recommended Books
                </h3>
                <div className="custom-scroll text-sm leading-relaxed max-h-24 overflow-y-auto pr-2">
                  {item.books
                    ? item.books
                    : "No Books available for this Subject."}
                </div>
              </div>

              {/* School Teaching Approach */}
              <div className="mb-4">
                <h3 className="font-semibold mb-1 text-lg">
                  School Teaching Approach
                </h3>
                <div className="custom-scroll text-sm leading-relaxed max-h-24 overflow-y-auto pr-2">
                  {item.approach
                    ? item.approach
                    : "No Teaching approach available."}
                </div>
              </div>
            </div>
          ))}
      </div>

      {data?.length === 0 && (
        <div className="h-[50vh] flex items-center justify-center w-full">
          <h1 className="text-center text-gray-400">No Data Found</h1>
        </div>
      )}
    </>
  );
};

export default Subjects;
